
import { Component, Prop, Vue } from 'vue-property-decorator';
import { toPascalCase } from '@/lib/GenericHelper';

@Component({
  name: 'BaseIcon',
})
export default class BaseIcon extends Vue {
  @Prop({ required: true, type: String }) icon!: string;
  @Prop({ required: true, type: String }) name!: string;
  currentIcon: any = null;

  get iconCSSClass(): string {
    // We fetch the CSS class for the icon using the name prop
    return this.$style[`baseIcon${toPascalCase(this.name)}`];
  }

  async created(): Promise<void> {
    // we asynchronsly load the asset SVG and dinamically load it as a component
    this.currentIcon = require(`@/assets/${this.icon}.svg`);
  }
}
